import { render, staticRenderFns } from "./CreateMaterialScience.vue?vue&type=template&id=47264fe2&scoped=true"
import script from "./CreateMaterialScience.vue?vue&type=script&lang=js"
export * from "./CreateMaterialScience.vue?vue&type=script&lang=js"
import style0 from "./CreateMaterialScience.vue?vue&type=style&index=0&id=47264fe2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47264fe2",
  null
  
)

export default component.exports